module.exports = __webpack_public_path__ + "img/case6.99440a88.png";